import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { InfiniteScrollTableUniDriver } from '../InfiniteScrollTable/InfiniteScrollTable.uni.driver';
import { CardsGridUniDriver } from '../Grid/CardsGrid.uni.driver';
import { CollectionToolbarUniDriver } from '../CollectionToolbar/CollectionToolbar.uni.driver';
import { baseUniDriverFactory } from '../../unidriver';
import { SummaryBarUniDriver } from '../SummaryBar/SummaryBar.uni.driver';

export function TableGridSwitchUniDriver(base: UniDriver, body: UniDriver) {
  const getToolbar = () =>
    CollectionToolbarUniDriver(
      base.$('[data-hook="collection-toolbar"]'),
      body,
    );

  const getTable = () => InfiniteScrollTableUniDriver(base, body);
  const getGrid = () => CardsGridUniDriver(base, body);
  const getSummaryBar = () => SummaryBarUniDriver(base, body);

  return {
    ...baseUniDriverFactory(base),
    /**
     * Wait until root element to exist
     * @param timeout - time to wait until bailing
     */
    wait: (timeout?: number) => base.wait(timeout),
    /** Get layout switch button */
    getSwitchButton: () => getToolbar().getSwitchButton(),
    /** Get layout switch button divider */
    getSwitchButtonDivider: () => getToolbar().getSwitchButtonDivider(),
    /** Get InfiniteScrollTable driver */
    getTable,
    /** Get CardsGrid driver */
    getGrid,
    isShowingGrid: () =>
      base.$(`[data-hook="toolbar-collection-content"]`).exists(),
    isShowingTable: async () =>
      !(await base.$(`[data-hook="toolbar-collection-content"]`).exists()),
    /**
     * Gets collection summary bar
     */
    getSummaryBar,
  };
}

export default TableGridSwitchUniDriver;
